import { render, staticRenderFns } from "./Folders3.vue?vue&type=template&id=a06db30c&scoped=true"
import script from "./Folders3.vue?vue&type=script&lang=js"
export * from "./Folders3.vue?vue&type=script&lang=js"
import style0 from "./Folders3.vue?vue&type=style&index=0&id=a06db30c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06db30c",
  null
  
)

export default component.exports